import { Project, ExtraFields } from '../../../models/project'

import * as model from '@owl-nest/models'
import { Reward } from '@owl-nest/models/src/reward'
import { Order, Supporter } from '@owl-nest/api-client/latest'

type FormattedBacker = {
  dateOrder: Date | undefined
  firstReward: Reward<ExtraFields> | undefined
  hasTip: boolean
  isLegacy: boolean
  isHidden: boolean
  labelColor: model.user.RoleTagBackgroundColor
  labelName: string | undefined
  supporterLatestOrder: Order | undefined
}

export function formatBacker(supporter: Supporter, project: Project): FormattedBacker {
  const supporterLatestOrder = supporter.latest_project_order

  const firstOrderItem = supporterLatestOrder?.items && supporterLatestOrder.items[0]
  const firstReward = firstOrderItem ? model.orderItem.getReward<ExtraFields>(firstOrderItem, project) : undefined
  const hasTip = supporterLatestOrder !== undefined && supporterLatestOrder.tip > 0
  const dateOrder = supporterLatestOrder ? new Date(supporterLatestOrder?.created_at) : undefined
  const label = supporter.labels ? model.user.label(supporter.labels[0]) : undefined
  const isLegacy = firstReward ? model.reward.isLegacy(firstReward) : false
  const isHidden =
    (supporterLatestOrder?.items ?? []).filter((item) => {
      const reward = model.orderItem.getReward<ExtraFields>(item, project)
      return reward?.is_hidden
    }).length > 0

  return {
    dateOrder,
    firstReward,
    hasTip,
    isLegacy: isLegacy,
    isHidden: isHidden,
    labelColor: label?.color,
    labelName: label?.label,
    supporterLatestOrder,
  }
}
